import React from 'react'
import styles from './Style.module.css';

const PriceDetails = ({cartTotal = 0, depositMoney = 0, isDepositPaid = false}) => {
  const parsedTotal = Number(cartTotal);
  const formattedTotal = (Number.isFinite(parsedTotal) ? parsedTotal : 0).toFixed(2);

  return (
    <div className={`${styles.serviceDetailCardContainer} space-y`}>
        {/* sub total  */}
        <div className={styles.serviceDetailCard}>
        <div className={styles.SDCLeft}>
            <h6 className={`${styles.flex} ${styles.bold}`}>
            Total
            </h6>
        </div>
        <div className={styles.SDCRight}>
            <h6 className={styles.bold}>From S${formattedTotal}+</h6>
        </div>
        </div> 

        {/* deposit  */}
        {/* <div className={`${styles.serviceDetailCard} ${styles.depositCard}`}>
        <div className={styles.SDCLeft}>
            <h6 className={styles.flex}>
            {isDepositPaid ? "Deposit Paid" : "Pay Deposit Now"}
            </h6>
        </div>
        <div className={styles.SDCRight}>
            <h6>S${depositMoney}</h6>
        </div>
        </div> */}

    </div>
  )
}

export default PriceDetails